// removed by extract-text-webpack-plugin
module.exports = {"block":"MainMenuAuth__block-2OhMi","loginButton":"MainMenuAuth__loginButton-39PsY","registerButton":"MainMenuAuth__registerButton-cCYwZ"};